import { FC } from "react";
import { Skeleton, Box } from "@mui/material";

interface PieChartLoaderProps {
  numberOfBars?: number;
}

const PieChartLoader: FC<PieChartLoaderProps> = ({ numberOfBars = 9 }) => {
  return (
    <Box
      className="pie-chart-loader"
      height="100%"
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Skeleton variant="text" height={20} sx={{ width: "80%" }} />
      <Box
        display="flex"
        flex={1}
        flexDirection={"row"}
        alignItems="center"
        gap={4}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={"50%"}
        >
          <Skeleton
            variant="circular"
            sx={{
              width: "100%",
              height: "auto",
              aspectRatio: "1/1",
            }}
          />
        </Box>

        <Box display="flex" flex={1} flexDirection="column" width="100%">
          {[...Array(numberOfBars)].map((itm) => (
            <Skeleton key={itm} variant="text" height={20} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PieChartLoader;
